<template>
  <div class="main">
    <main class="container alianca-content">
      <section class="row">
        <div class="main-content col-12">
          <div id="cadastrar">

            <loading 
                :active.sync="isLoading" 
                :can-cancel="false" 
                :is-full-page="true"
                class="overlay-load">
            </loading>

            <transition name="fade">
              <div id="step-1" class="multi-step-form active-step" v-if="etapa==='step-1'">
                <div class="d-flex align-content-center">
                  <p><img
                        src="../assets/arrow-left.svg"
                        alt="Voltar etapa"
                        @click.prevent="backtoplanos()"
                      /></p>
                </div>
                <div class="align-flex-title" style="margin-top: -58px">
                  <h3>Cadastro/Login</h3>
                </div>
                <div class="div-chamada-cadastro">
                  <p class="chamada-cadastro">Para adquirir um dos nossos planos, precisamos que você finalize seu cadastro para concluir a sua compra, é bem rápido.</p>
                </div>

                <div class="div-notificacao-lgpd" v-if="consentimentolgpd == false">
                  <p class="chamada-cadastro">Este passo é simples, solicitamos apenas o seu aceite aos nossos <b style="cursor: pointer" v-b-modal.modal-consentimento-lgpd>termos de uso</b> para continuar</p>
                </div>

                <div style="margin-top: 40px">
                  <b-button class="btn-alianca pesquisar-planos big-btn-cadastro" @click="setEtapa('step-1','step-2')" :disabled="!consentimentolgpd">Finalize seu cadastro</b-button>
                </div>
                <div style="margin-top: 40px">
                  <b-button class="btn-alianca pesquisar-planos pesquisar-planos-inverse big-btn-cadastro" @click="setEtapa('step-1','login')">Fazer login</b-button>
                </div>

                <b-modal id="modal-consentimento-lgpd">
                  <template #modal-header="{ close }">
                    <div style="margin: 0">
                      <h5 class="title-modal">Termos de uso e política de privacidade</h5>
                    </div>
                    <div style="margin: 0">
                      <b-button class="close btn-close btn-modais-nohover" aria-label="Close" @click="close()">×</b-button>
                    </div>
                  </template>
                  <termo-lgpd />
                  <template #modal-footer="{ close }">
                    <div @click="consentimentolgpd = true; defineConsentimento(); close()">
                      <b-button class="btn-alianca btn-next btn-clicked btn-next-continuar-simule-lgpd">ACEITAR OS TERMOS E CONTINUAR</b-button>
                      <b-button class="btn-alianca btn-next btn-icon-next btn-clicked-icon"><font-awesome-icon icon="angle-right" class="icon-arrow-right" /></b-button>
                    </div>
                  </template>
                </b-modal>
              </div>
            </transition>

            <transition name="fade">
              <div id="step-2" class="multi-step-form active-step" v-if="etapa==='step-2'">
                <div class="d-flex align-content-center">
                  <p><img
                        src="../assets/arrow-left.svg"
                        alt="Voltar etapa"
                        @click.prevent="prevEtapa('step-1')"
                      /></p>
                </div>
                <div class="align-flex-title" style="margin-top: -58px">
                  <h3>Cadastro/Login</h3>
                </div>
                <div class="row" style="display: block; text-align: left">
                  <p>CPF:</p>
                  <b-form-input v-model="cpf" placeholder="Digite aqui o seu CPF" v-mask="'###.###.###-##'" @keydown="onKeydown($event)" :class="{ 'statusok-fontbold': cpf.length > 13 }"></b-form-input>
                  <img
                    v-if="cpf.length > 13"
                    class="statusok-check"
                    src="../assets/statusok.svg"
                    alt="Voltar etapa"
                  />
                </div>
                <!-- <div class="row" style="display: block; text-align: left">
                  <p>Data de nascimento:</p>
                  <b-form-input v-model="datanasc" placeholder="Digite aqui a sua data de nascimento" v-mask="'##/##/####'"></b-form-input>
                </div> -->
                <div class="form-row" style="text-align: left; justify-content: space-between;">
                  <div class="form-group col-md-8">
                    <p>CEP:</p>
                    <b-form-input v-model="cep" placeholder="00000-000" v-mask="'#####-###'" @keydown="onKeydown($event)" :class="{ 'statusok-fontbold': cep.length > 8 }"></b-form-input>
                    <img
                      v-if="cep.length > 8"
                      class="statusok-check"
                      src="../assets/statusok.svg"
                      alt="Voltar etapa"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <p>Número:</p>
                    <b-form-input v-model="numerocasa" placeholder="Nº" @keydown="onKeydown($event)" :class="{ 'statusok-fontbold': numerocasa.length > 0 }"></b-form-input>
                    <img
                      v-if="numerocasa.length > 0"
                      class="statusok-check"
                      src="../assets/statusok.svg"
                      alt="Voltar etapa"
                    />
                  </div>
                </div>
                <div class="row" style="display: block; text-align: left">
                  <p>Tipo de endereço:</p>
                  <b-form-select v-model="tipoendereco" :options="options_tipoendereco" :class="{ 'statusok-fontbold': tipoendereco != null }" :style="[ tipoendereco != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]">
                    <b-form-select-option :value="null">Selecione o tipo de endereço</b-form-select-option>
                  </b-form-select>
                </div>
                <!-- <div class="row" style="display: block; text-align: left">
                  <p>Telefone:</p>
                  <b-form-input v-model="telefone" placeholder="(__) _____ - ____" v-mask="'(##) #####-####'"></b-form-input>
                  <small>Vamos utilizar para entrar em contato se você tiver dúvidas</small>
                </div>
                <div class="row" style="display: block; text-align: left">
                  <p>Email:</p>
                  <b-form-input v-model="email" placeholder="Digite aqui o seu Email"></b-form-input>
                  <small>Vamos utilizar para envio de simulação</small>
                </div> -->
                <div class="row" style="display: block; text-align: left">
                  <p>Senha:</p>
                  <b-form-input v-model="senha" placeholder="Digite aqui a sua senha" type="password" maxlength="10" :class="{ 'statusok-fontbold': /\d/.test(senha) && senha.length >= 6 && this.senha.length <= 10 }"></b-form-input>
                  <img
                    v-if="/\d/.test(senha) && senha.length >= 6 && this.senha.length <= 10"
                    class="statusok-check"
                    src="../assets/statusok.svg"
                    alt="Voltar etapa"
                  />
                  <small>Sua senha deve conter de 6 a 10 dígitos entre letra(s) e número(s).</small>
                </div>
                <div class="row" style="display: block; text-align: left">
                  <p>Confirme sua Senha:</p>
                  <b-form-input v-model="confirmasenha" placeholder="Digite novamente sua senha" type="password" maxlength="10" :class="{ 'statusok-fontbold': confirmasenha.length > 0 && senha === confirmasenha }"></b-form-input>
                  <img
                    v-if="confirmasenha.length > 0 && senha === confirmasenha"
                    class="statusok-check"
                    src="../assets/statusok.svg"
                    alt="Voltar etapa"
                  />
                </div>
                <!-- TESTE VALIDAÇÃO -->
                <div v-if="errors.length"> 
                  <b v-for="erro in errors" :key="erro">{{ erro }}</b>                    
                </div> 
                <!-- TESTE VALIDAÇÃO -->
                <div class="row consentimento-div">
                  <!-- <small>Ao clicar em cadastrar você aceita todos os termos de uso. <a href="#" style="margin-left: 5px" v-b-modal.modal-saibamais-termos>Ver os termos</a></small> -->
                  <div @click="gotologin()">
                    <b-button class="btn-alianca btn-next btn-next-cadastra" :class="{ 'btn-clicked': senha != '' && senha === confirmasenha && cpf != '' }">Cadastrar</b-button>
                    <b-button class="btn-alianca btn-next btn-icon-next" :class="{ 'btn-clicked-icon': senha != '' && senha === confirmasenha && cpf != '' }"><font-awesome-icon icon="angle-right" class="icon-arrow-right" /></b-button>
                  </div>
                </div>
                <b-modal id="modal-saibamais-termos">
                  <template #modal-header="{ close }">
                    <div style="margin: 0">
                      <h5 class="title-modal">Termos de uso</h5>
                    </div>
                    <div style="margin: 0">
                      <b-button class="close btn-close" aria-label="Close" @click="close()">×</b-button>
                    </div>
                  </template>
                  <div>
                  </div>
                  <template #modal-footer><span></span></template>
                </b-modal>
              </div>
            </transition>
          </div>
        </div>
      </section>
      <div v-if="!adesaoFinalizada" style="margin: 0">
        <fale-conosco />
      </div>
      <modal-abandono-pagina v-if="!adesaoFinalizada" />
    </main>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueMask from 'v-mask'
  import cadastrarUsuario from "../services/cadastrarUsuario"
  import inserirPreCadastro from "../services/inserirPreCadastro"
  import liberarPreCadastro from "../services/liberarPreCadastro"
  import Loading from 'vue-loading-overlay'
  import store from "../store"
  Vue.use(VueMask);

  export default {
    name: 'Cadastrar',
    components: {
      Loading
    },
    data(){
      return {
        cep: '',
        numerocasa: '',
        tipoendereco: null,
        cpf: '',
        nome: '',
        datanasc: '',
        email: '',
        telefone: '',
        senha: '',
        confirmasenha: '',
        etapa: 'step-1',
        errors: [],
        isLoading: false,
        consentimentolgpd: store.getters.getAliancaConsentimentoLGPD,
        options_tipoendereco: [
          { value: 'R' , text: 'RESIDENCIAL' },
          { value: 'C' , text: 'COMERCIAL' },
        ]
      }
    },
    methods: {
      formatter(val){
        return val.toUpperCase();
      },
      defineConsentimento(){
        store.commit('mutAliancaConsentimentoLGPD', this.consentimentolgpd)
      },
      async cadastrarUsuarioAPI(){
        try {
          this.isLoading = true
          
          let datanasc = store.getters.getAliancaDataNasc
          datanasc = datanasc.substr(6, 4) + '/' + datanasc.substr(3, 2) + '/' + datanasc.substr(0, 2)

          let dataString = datanasc.split("/").reverse();
          let data = `${dataString[2]}${dataString[1]}${dataString[0]}`

          let today = new Date();
          today = today.getFullYear() + '' + (today.getMonth()+1) + '' + today.getDate();

          let current = new Date(); 
          current = current.getHours() + ":" + current.getMinutes() + ":" + current.getSeconds();

          let usrretorno = await inserirPreCadastro({
            beneficiario: {
                nome: store.getters.getAliancaNome,
                cpf: store.getters.getAliancaUsrCPF.replace('-','').replace('.', '').replace('.', ''),
                data_nascimento: data,
                ddd_cel: store.getters.getAliancaTelefone.substr(1, 2),
                telefone_celular: store.getters.getAliancaTelefone.substr(6, 10).replace('-',''),
                email: store.getters.getAliancaEmail
            },
            endereco:{
                cep: store.getters.getAliancaCEP.replace('-','')
            },
            usuarioLogado: {
                senha: this.senha,
                dataCadastro: today,
                horaCadastro: current
            }
          })
          if ( usrretorno != undefined && usrretorno.ZC0_CODIGO ){
            let codigo = usrretorno.ZC0_CODIGO

            let liberarcadastro = await liberarPreCadastro({
                codigo
            })

            if (liberarcadastro){
              console.log('Usuario de código ' + codigo + ' liberado')

              let bodyreq = {
                "Cpf" : store.getters.getAliancaUsrCPF.replace('-','').replace('.', '').replace('.', ''),
                "Nome" : store.getters.getAliancaNome,
                "Email" : store.getters.getAliancaEmail,
                "DtNasc" : data,
                "Cep" : store.getters.getAliancaCEP.replace('-',''),
                "Endereco" : store.getters.getAliancaEndRua,
                "Numero" : this.numerocasa,
                "Complemento" : store.getters.getAliancaEndComp,
                "Municipio" : store.getters.getAliancaEndCidade,
                "Estado" : store.getters.getAliancaEndUF, 
                "DDD" : store.getters.getAliancaTelefone.substr(1, 2),
                "Celular" : store.getters.getAliancaTelefone.substr(6, 10).replace('-',''),
                "Senha" : this.senha
              }
              let usrretorno = await cadastrarUsuario(bodyreq)
              if ( usrretorno && usrretorno.Status || usrretorno.Mensagem === "009-CPF/CNPJ ou e-mail ja estao cadastrados.(login)" ){
                store.commit("mutAliancaObjCadastro", usrretorno)
                this.isLoading = false
                return true
              } else {
                store.commit("mutAliancaObjCadastro", usrretorno) 
                this.errors.push('Usuário já cadastrado, tente fazer login e/ou recuperar a senha')
                return false
              } 

            } else {
              this.errors.push('Ocorreu um erro ao tentar liberar o pré cadastro, tente novamente')
              this.isLoading = false
              return false
            }
            
          } else {
            this.errors.push('Um erro ocorreu ao tentar inserir pré cadastro, tente novamente')
            this.isLoading = false
            return false
          } 
        } catch(e) {
          console.log("erro cadastro", e);
          this.errors.push('Houve um problema em realizar o cadastro. Tente novamente mais tarde.');
          this.isLoading = false
        }
      },
      onKeydown: function(e) {

        if (
          // permite somente numeros
          (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) ||
          // permite teclas lado direito, esquerdo, delete, backspace, tab e enter
          /^(8|9|13|46|37|39|17)$/.test(e.keyCode) ||
          // permite ctrl+ c,v,x,a,z
          /^(67|86|88|65|90)$/.test(e.keyCode) && e.ctrlKey
        ) return;
        e.preventDefault();
        e.stopPropagation();        
      
      },
      TestaCPF(strCPF) {
        let Soma
        let Resto
        Soma = 0
        if (strCPF == "00000000000") return false

        for ( let i = 1; i <= 9; i++ ) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i)
        Resto = (Soma * 10) % 11

        if ((Resto == 10) || (Resto == 11))  Resto = 0
        if (Resto != parseInt(strCPF.substring(9, 10)) ) return false

        Soma = 0;
        for ( let i = 1; i <= 10; i++ ) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i)
        Resto = (Soma * 10) % 11

        if ((Resto == 10) || (Resto == 11))  Resto = 0
        if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false
        return true
      },
      async validaCadastro(){
        this.errors = []

        // Verificar se existe CPF na base de dados - process.env.VUE_APP_ALIANCAADM_ADESAO + /pesquisarUsuarioExistente?cpf=this.cpf.replace('-','').replace('.', '').replace('.', '') -->
        
        if ( !this.TestaCPF(this.cpf.replace('-','').replace('.', '').replace('.', '')) || !this.cpf ){
          this.errors.push('Preencha seu CPF corretamente')
          return false
        } 

        if ( !this.numerocasa ) {
          this.errors.push('Insira um número valido do endereço')
          return false
        }

        if ( this.tipoendereco == null ) {
          this.errors.push('Selecione um tipo de endereço valido')
          return false
        }

        if ( this.senha.length < 6 || this.senha.length > 10 ) {
          this.errors.push('A senha não possui entre 6 a 10 caracteres')
          return false
        }

        if ( this.senha !== this.confirmasenha ) {
          this.errors.push('As senhas não são iguais')
          return false
        }

        if ( !/\d/.test(this.senha) ) {
          this.errors.push('A senha não possui caracteres numéricos')
          return false
        }
        let res = await this.cadastrarUsuarioAPI();
        return res
      },
    
      backtoplanos(){
        store.commit('mutAliancaSelectedPlano', null)
        document.getElementById('step-progress-point3').classList.remove("rounded-point-progress-ok")
        document.getElementById('globaletapa3').classList.add("etapas-progresso-texto-disabled")
        this.$router.push("seu-plano")
      },
      async gotologin(){
        let res = await this.validaCadastro();
        if (res){
          store.commit('mutAliancaEndNumero', this.numerocasa)
          store.commit('mutAliancaUsrCPF', this.cpf)
          store.commit('mutAliancaUsrSenha', this.senha)
          store.commit('mutAliancaTipoEndereco', this.tipoendereco)

          this.$router.push("login")
        }
      },
      prevEtapa(anterior) {
        this.etapa = anterior
        store.commit('mutAliancaProxEtapa', anterior)
      },
      async setEtapa(atual, prox){
        switch (atual) {
          case 'step-1':
            if (prox == 'login'){
              this.$router.push("login")
            } else {
              this.etapa = prox
            }
            break;
        }  
      }
    },
    mounted(){
      store.commit("mutAliancaBreakPlanos", true);
      document.getElementById('step-progress').value = 69.69
      document.getElementById('step-progress-point1').classList.add("rounded-point-progress-ok")
      document.getElementById('step-progress-point2').classList.add("rounded-point-progress-ok")
      document.getElementById('step-progress-point3').classList.add("rounded-point-progress-ok")
      document.getElementById('globaletapa2').classList.remove("etapas-progresso-texto-disabled")
      document.getElementById('globaletapa3').classList.remove("etapas-progresso-texto-disabled")

      for (let i = 1; i <= 4; i++){
        document.getElementById('globaletapam' + i).classList.remove("etapas-progresso-mobile-show")
        document.getElementById('globaletapaprox' + i).classList.remove("div-proximo-etapa-mobile-show")
      }

      document.getElementById('globaletapam3').classList.add("etapas-progresso-mobile-show")
      document.getElementById('globaletapaprox3').classList.add("div-proximo-etapa-mobile-show")

      document.getElementById('header').classList.remove("header-fixed")
    },
    created() {
      let selectedplanocomprar = store.getters.getAliancaSelectedPlano
      if (selectedplanocomprar != null){
        if (store.getters.getAliancaUsrCPF != null) {
          if (store.getters.getAliancaObjLogin != null) {
            if (store.getters.getAliancaObjLogin.Status) this.$router.push("dados-beneficiario")
          }
        }

        this.cpf = store.getters.getAliancaUsrCPF
        this.nome = store.getters.getAliancaNome
        this.cep = store.getters.getAliancaCEP
        this.datanasc = store.getters.getAliancaDataNasc
        this.telefone = store.getters.getAliancaTelefone
        this.email = store.getters.getAliancaEmail
      } else {
        this.$router.push("seu-plano")
      }
    },
    computed: {
      adesaoFinalizada() {
        return this.$route.name === 'adesao-finalizada';
      },
    },
    destroyed() {
      store.commit("mutAliancaBreakPlanos", false);
    }
  }
</script>
